angular.module('accessWebClient')
    .controller('UploadRequestShareLinkController', [
        '$scope',
        '$modalInstance',
        'uploadRequest',
        function ($scope, $modalInstance, uploadRequest) {
            $scope.modal = $modalInstance.options;
            $scope.uploadRequest = uploadRequest;
            $scope.showCopyLinkOption = angular.isUndefined(uploadRequest.isActive) || uploadRequest.isActive;
            $scope.copyLinkText = $scope.showCopyLinkOption ? 
                'upload_requests_upload_share_link_copy_text' :
                'upload_requests_upload_share_link_expired_revoked_link_text';

            $scope.close = $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        }
    ]);
